import { findAllParameters } from '@src/main/modules/parameters/application/find/find-all-parameters.usecase';
import { createParameterHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ParameterHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useParameters = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createParameterHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['parameter'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllParameters(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
